<template>
  <section class="unity-wrap">
    <!--    <div class="is-center has-text-centered">-->
    <!--      <button-->
    <!--        class="button is-outlined is-small is-dark"-->
    <!--        @click="callPopup($event, 1)"-->
    <!--      >-->
    <!--        Launch popup 1-->
    <!--      </button>-->
    <!--      <button-->
    <!--        class="button is-outlined is-small is-dark"-->
    <!--        @click="callPopup($event, 2)"-->
    <!--      >-->
    <!--        Launch popup 2-->
    <!--      </button>-->
    <!--    </div>-->

    <!--    <b-modal :active="isPopup1Active" :on-cancel="ClosePopup1">-->
    <!--      <p class="video is-4by3">-->
    <!--        <video src="static/img/video.mp4" controls></video>-->
    <!--      </p>-->
    <!--    </b-modal>-->

    <unity
      src="static/Build/Build.json"
      unityLoader="static/Build/UnityLoader.js"
      :hideFooter="true"
      :externalProgress="onUnityProgress"
    ></unity>
    <transition name="fade">
      <unity-preloader
        :progress="progress"
        loadDelay="3"
        v-if="showPreloader"
      ></unity-preloader>
    </transition>
  </section>
</template>

<script>
import Unity from "vue-unity-webgl";
import UnityPreloader from "./UnityPreloader";
import { mapState } from "vuex";

export default {
  components: { "unity-preloader": UnityPreloader, Unity },
  data() {
    return {
      progress: 0,
      loaded: 0,
    };
  },
  computed: {
    ...mapState(["config"]),
    showPreloader() {
      if (this.config.has_intro_audio) {
        return this.loaded < 2;
      } else {
        return this.loaded < 1;
      }
    },
  },
  methods: {
    onUnityProgress(gameInstance, progress) {
      console.log(this.progress, "<<<<");
      this.progress = progress;
    },
    onUnityLoaded() {
      this.loaded += 1;
    },
    onAudioEnded() {
      this.loaded += 1;
    },
  },
  mounted() {
    this.$eventBus.$on("unityLoaded", this.onUnityLoaded);
    this.$eventBus.$on("audioEnded", this.onAudioEnded);
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
